import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { Spinner } from 'src/components/Spinner';

export function LoginPage() {

  const { isLoading, loginWithRedirect } = useAuth0();

  const doLogin = () => {
    const authConfig =
    {
      appState: {
        returnTo: '/'
      },
    }
    loginWithRedirect(authConfig);
  }

  useEffect(() => {
    doLogin()
  },[loginWithRedirect]);

  if (isLoading) {
    return <Spinner />
  }

  return (
    <div className="uk-container">
      <div className="uk-card uk-card-default uk-card-body">
        <h3 className="uk-card-title">Logging in</h3>
      </div>
    </div>
  )
}